import { render, staticRenderFns } from "./PageSectionWithForm.vue?vue&type=template&id=5ee53a5c"
import script from "./PageSectionWithForm.vue?vue&type=script&lang=js"
export * from "./PageSectionWithForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports